import { fetchSectionResults, handleSectionResponse } from '../shared/singleSectionSearch.js';
import { renderPagination } from '../shared/pagination.js';
import { elements } from './elements.js';
import { pgQueryParam, serverDateTimeSecondsFormat, friendlyDateFormat, addClass, removeClass, hiddenClass } from '../../../config.js';
import { getQueryParam, updateQueryString } from '../shared/utils.js';
import { formDataParsing } from './calendar.js';
import { format, parse } from 'date-fns';

const onPageLinkClick = (page) => {
    updateQueryString({ [pgQueryParam]: page });
    fetchResults(page);
};

export const fetchResults = (page = parseInt(getQueryParam(pgQueryParam)) || 1) => {
    // Loading skeletons
    removeClass(elements.loadingSkeletons, hiddenClass);
    addClass(elements.resultsContainer, hiddenClass);

    fetchSectionResults(
        'search/news',
        elements,
        page,
        (pagination) => renderPagination(pagination, onPageLinkClick),
        (response, resultsContainer) => {
            addClass(elements.loadingSkeletons, hiddenClass);
            removeClass(elements.resultsContainer, hiddenClass);

            handleSectionResponse(response, resultsContainer, elements.noResultsContainer, 'news-library-item-template', (item, news) => {
                const links = item.querySelectorAll('a');
                links.forEach(link => link.href = news.url);

                item.querySelector('.js-news-title').textContent = news.title || 'Untitled';
                item.querySelector('.js-news-teaser').textContent = news.teaserText || '';
                item.querySelector('.js-news-type').textContent = news.articleType || 'News';

                if (news.postDate) {
                    const dateParsed = parse(news.postDate, serverDateTimeSecondsFormat, new Date());
                    item.querySelector('.js-news-date').textContent = format(dateParsed, friendlyDateFormat);
                }
            });
        },
        formDataParsing
    );
};
